import LinkedText from "../LinkedText";
import RepomanceIcon from "../../assets/img/apps/repomance/repomance.png";

export default function IosAppsTable() {
    const iconStyle = {
        width: "1.5em",
        height: "1.5em",
        objectFit: "contain",
        flexShrink: 0,
        display: "block",
        marginLeft: 0
    };
    
    const appNameStyle = {
        display: "flex",
        alignItems: "center",
        gap: "5px",
    };
    
    const freeStyle = {
        fontWeight: "bold",
        color: "#2aef0c",
    };

    return (
        <>
            <h2 style={appNameStyle}><img style={iconStyle} src={RepomanceIcon} alt={"Repomance"}/>Repomance <span style={freeStyle}>(Free)</span> </h2>
            <p className="mb-0">Tinder for GitHub repositories. Swipe to star using your GitHub account.
                <br/>Click <LinkedText href={"https://repomance.com"} text={"here"}/> to learn more.
            </p>
        </>
    )
}